import React from "react"
import {
	Box,
	Typography,
} from "@mui/material"
import Chart from "chart.js/auto"
import "chart.js"
import {
	Point,
	BubbleDataPoint,
} from "chart.js"
import { customColors } from "customColors"
import {Trans} from "@lingui/macro";
import { Circle } from "@mui/icons-material"
import {MatchingData} from "../../../models";

export interface DashboardMatchingProps
{
	matchingData: MatchingData
}

export interface DashboardMatchingState
{
}
export class DashboardMatching extends React.Component<DashboardMatchingProps, DashboardMatchingState> {

	private chartRefPie: React.RefObject<HTMLCanvasElement> = React.createRef();
	private myChart: Chart<"pie", (number | [number, number] | Point | BubbleDataPoint | undefined)[], string> | null = null;
	private isSmallScreen: boolean = window.innerWidth < 1024;

	public componentDidMount()
	{
		this.createChart()
		window.addEventListener("resize", this.handleResize);
	}

	componentWillUnmount() {
		if (this.myChart) {
			this.myChart.destroy();
		}
		window.removeEventListener("resize", this.handleResize);
	}

	handleResize = () => {
		if (this.myChart) {
			this.myChart.resize();
		}
	};

	createChart = () => {
		const canvas = this.chartRefPie.current;
		const data: (number | [number, number] | Point | BubbleDataPoint | undefined)[] = [
			this.props.matchingData.notMatching,
			this.props.matchingData.matching,
			this.props.matchingData.rejectedMatches
		];
		const lineChartType: 'pie' = 'pie';

		if (canvas) {
			const ctx = canvas.getContext("2d")
			if (ctx) {
				if (this.myChart) {
					this.myChart.destroy();
				}

				this.myChart = new Chart(ctx, {
					type: lineChartType,
					data: {
						labels: ['Immobili', 'Match trovati', 'Match rifiutati'],
						datasets: [{
							data: data,
							label: 'Numero elementi',
							backgroundColor: [customColors.storebookBlue, customColors.storebookGreen, customColors.storebookRed]
						}],
					},
					options: {
						rotation: (200 * Math.PI),
						maintainAspectRatio: false,
						plugins: {
							legend: {
								display: false,
							},
						},
					},
				})
			}
		}
	};

	private isDataPresent = (): boolean => {
		return this.props.matchingData.notMatching !== 0;
	}

	render()
	{

		return (
			<Box sx={{ backgroundColor: 'background.default',
				width: '100%',
				height: "100%",
				display: "flex",
				flexDirection: "column",
			}}>
				<header >
					<Box sx={{ backgroundColor: customColors.storebookBlue, paddingLeft: 3, paddingY: 2, color: 'white', textAlign: 'left' }}>
						<Typography fontSize={16}>
							Panoramica matching
						</Typography>
					</Box>
				</header>

				{!this.isDataPresent() &&
				<Box sx={{
					width: '100%',
					height: this.isSmallScreen ? '300px' : '380px',
					paddingX: this.isSmallScreen ? '15%' : '24%',
					textAlign: "center",
					display: "flex",
					justifyContent: "center",
					alignItems: "center"}}>
					<Typography>
						<Trans id="dashboard-matching.no-data">
							Nessun dato trovato
						</Trans>
					</Typography>
				</Box>
				}

				{this.isDataPresent() &&
					<>
						<Box textAlign="center" mt={2} display="flex" alignItems="center" justifyContent="center">
							<Box width="33%" textAlign="center" display="flex" alignItems="center" justifyContent="center">
								<Circle sx={{color: customColors.storebookBlue}} />
								<Typography fontSize="0.9em" sx={{ml: 2}}>Immobili</Typography>
							</Box>

							<Box width="33%" textAlign="center" display="flex" alignItems="center" justifyContent="center">
								<Circle sx={{color: customColors.storebookGreen}} />
								<Typography fontSize="0.9em" sx={{ml: 2}}>Match trovati</Typography>
							</Box>

							<Box width="33%" textAlign="center" display="flex" alignItems="center" justifyContent="center">
								<Circle sx={{color: customColors.storebookRed}} />
								<Typography fontSize="0.9em" sx={{ml: 2}}>Match rifiutati</Typography>
							</Box>
						</Box>

						<Box
							sx={{
								width: '100%',
								mx: "auto",
								mt: 3,
								mb: 2,
								flexGrow: 1,
							}}>
							<canvas ref={this.chartRefPie}></canvas>
						</Box>
					</>
				}
			</Box>
		)
	}
}
